import { c as _c } from "react/compiler-runtime";
import useChatMessageStore from '@module/stores/useChatMessageStore';
import { useEffect, useRef, useState } from 'react';
const BOTTOM_THRESHOLD = 50;
const useChatScrollController = () => {
  const $ = _c(9);
  const chatMessages = useChatMessageStore(_temp);
  const scrollRef = useRef(null);
  const [isNearBottom, setIsNearBottom] = useState(true);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (!scrollRef.current) {
        return;
      }
      const element = scrollRef.current;
      const onUserScroll = () => {
        setIsNearBottom(element.scrollHeight - element.scrollTop <= element.clientHeight + BOTTOM_THRESHOLD);
      };
      if (element) {
        element.addEventListener("scroll", onUserScroll);
      }
      return () => {
        if (element) {
          element.removeEventListener("scroll", onUserScroll);
        }
      };
    };
    t1 = [scrollRef];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isNearBottom) {
    t2 = () => {
      const element_0 = scrollRef.current;
      if (element_0 && isNearBottom) {
        element_0.scrollTop = element_0.scrollHeight;
      }
    };
    $[2] = isNearBottom;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== chatMessages || $[5] !== isNearBottom) {
    t3 = [chatMessages, isNearBottom];
    $[4] = chatMessages;
    $[5] = isNearBottom;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== isNearBottom) {
    t4 = {
      scrollRef,
      isNearBottom
    };
    $[7] = isNearBottom;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default useChatScrollController;
function _temp(state) {
  return state.chatMessages;
}